import 'css-chunksrc/client/common/layout/zonesList/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_15cgh_1",
  "button": "_button_15cgh_23"
};